import { Component, Inject, OnInit } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralService } from '../shared/services/general.service';
import { RouteService } from '../shared/services/route.service';
import { HomeMenus, MenuRuter } from '../shared/models/home-model/home.model';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TaskList } from '../general-page/hybrid-page/task-list/task-list';
import { NewQuotation } from '../new-quotation/new-quotation/new-quotation';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    NewQuotation,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
  public menuRuter: HomeMenus | null = null;
  public userMenus!: RouteService['menuCarvesrt'];

  constructor(
    private router: Router,
    private servicesGeneral: GeneralService,
    public http: HttpClient,
    @Inject(RouteService) private routeService: RouteService,
  ) {
    this.userMenus = this.routeService.menuCarvesrt;
  }

  ngOnInit() {
    const token = localStorage.getItem('token');
    if (!token) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login']);
      return;
    }
  }

  public navigateMenu(menu: MenuRuter, indexSelected: number, isTab: boolean): void {
    if (isTab) {
      this.goToUrl([menu.url ?? ''], { indexSelected });
    } else {
      this.router.navigate([menu.url]);
    }
  }

  public goToUrl(route: string[], queryParams: { [key: string]: string | number }) {
    this.servicesGeneral.goToUrl(route, queryParams);
  }
}
